import Swiper from 'swiper/js/swiper';
import { getCurrentDevice, videoControlPlayer } from './utils';

export const initSlider = (selector, options = {}, container) => {
	$(selector, container).each((index, el) => {
		const $slider = $(el).find('.swiper-container');
		const $paging = $(el).find('.js-paging');
		const $items = $(el).find('.swiper-slide');
		const $totalEl = $(el).find('.js-total');
		const $currentEl = $(el).find('.js-current');
		let autoplay = $(el).data('autoplay');

		let lastActiveRealIndex = 0;

		let slidesCount = options.slidesPerView;

		if(getCurrentDevice() === 'tablet' && options.slidesPerViewTablet) {
			slidesCount = options.slidesPerViewTablet;
		}

		if(getCurrentDevice() === 'desktop' && options.slidesPerViewDesktop) {
			slidesCount = options.slidesPerViewDesktop;
		}

		/* If there is only one item we hide the pagination (CSS)
			 * and stop the loop or anything allowing to slide */
		if (options.slidesPerView !== 'auto') {
			const limit = slidesCount ? slidesCount : 1;

			if ($items.length <= limit) {
				disableSlider();
			}
		} else {
			if ( $items.length < 2 ) {
				disableSlider();
			}
		}

		$totalEl.text($items.length);
		$currentEl.text(1);

		if (autoplay) {
			autoplay = {
				delay: 5000,
			}
		} else {
			autoplay = false
		}

		const slider = new Swiper ($slider, {
			autoplay,
			loop: true,
			loopedSlides: 5,
			speed: 500,
			simulateTouch: false,
			preloadImages: false,
			lazy: true,
			navigation: {
				prevEl: $paging.find('.js-paging-prev'),
				nextEl: $paging.find('.js-paging-next'),
			},
			pagination: {
				el: $slider.find('.js-slider-bullets'),
				type: 'bullets',
				clickable: true
			},
			...options,
		});

		slider.on('slideChange', () => {
			setTimeout(() => {
				$currentEl.text(slider.realIndex + 1);
			}, 100);
		});

		slider.on('slideChangeTransitionStart', function () {
            const $activeSlide = $slider.find('.swiper-slide-active');
            const $previousSlideLoops = $slider.find(`.swiper-slide[data-swiper-slide-index="${lastActiveRealIndex}"]`);
            videoControlPlayer($('iframe', $activeSlide), 'play');
            videoControlPlayer($('iframe', $previousSlideLoops), 'pause');
            lastActiveRealIndex = slider.realIndex;
        });

		function disableSlider() {
			$(el).addClass('not-initialized');

			options.loop = false;
			options.centeredSlides = false;
			options.allowTouchMove = false;

			$totalEl.parent().addClass('hidden');
		}

		$(el).find('.js-autoplay-play').on('click', function() {
			slider.autoplay.start();

			$slider.addClass('playing');
			$slider.removeClass('pause');
		});

		$(el).find('.js-autoplay-pause').on('click', function() {
			slider.autoplay.stop();

			$slider.removeClass('playing');
			$slider.addClass('pause');
		});
	});
}

export default container => {
	initSlider('.js-slider-items', {
		slidesPerView: 1,
		slidesPerViewDesktop: 3,
		slidesPerViewTablet: 2,
		breakpoints: {
			1025: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 16,
			}
		}
	}, container);
	
	initSlider('.js-slider-amenities', {
		slidesPerView: 1,
		slidesPerViewDesktop: 4,
		slidesPerViewTablet: 2,
		breakpoints: {
			1025: {
				slidesPerView: 4,
				spaceBetween: 16,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 16,
			}
		}
	}, container);
	
	initSlider('.js-slider-spothlight', {
		speed: 500,
		slidesPerView: 1,
		slidesPerViewDesktop: 4,
		slidesPerViewTablet: 2,
		loop: false,
		breakpoints: {
			1025: {
				slidesPerView: 4,
				spaceBetween: 50,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 50,
			}
		}
	}, container);
	
	initSlider('.js-slider-highlights', {
		slidesPerView: 1,
		slidesPerViewDesktop: 3,
		slidesPerViewTablet: 1,
		breakpoints: {
			1025: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			768: {
				slidesPerView: 1,
				spaceBetween: 16,
			}
		}
	}, container);
	
	initSlider('.js-slider-services', {
		slidesPerView: 1,
		slidesPerViewDesktop: 5,
		slidesPerViewTablet: 3,
		breakpoints: {
			1025: {
				slidesPerView: 5,
				spaceBetween: 16,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 16,
			}
		}
	}, container);
	
	initSlider('.js-slider-featured', {
		autoHeight: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		speed: 1000,
	}, container);
	
	initSlider('.js-slider-text', {}, container);
	
	initSlider('.js-slider-offers-featured', {
		autoHeight: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		speed: 1000,
		autoplay: {
			delay: 5000,
		},
	}, container);
	
	initSlider('.js-slider-images', {
		simulateTouch: true
	}, container);
	
	initSlider('.js-slider-module', {}, container);
	
	if (getCurrentDevice() === 'mobile') {
		initSlider('.js-slider-image-items', {
			slidesPerView: 1
		}, container);
	}

	initSlider('.js-hero', {
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		speed: 1000,
	}, container);
}
